var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v(" Создание сотрудника "), _c('div', {
    staticClass: "ml-5"
  }, [_c('v-btn', {
    staticClass: "mx-4",
    attrs: {
      "small": "",
      "color": "primary",
      "outlined": "",
      "to": "/users"
    }
  }, [_vm._v("Все сотрудники")])], 1)]), _c('UserForm')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }